import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Fade from "@material-ui/core/Fade";
import Img from "gatsby-image";
import Title from "./title";


const Header = ({ data, line1, line2 }) => {
  
  
  return (
    <Grid
      item
      style={{
        height: `calc(100vw / ${data.a9.childImageSharp.fluid.aspectRatio})`,
        position: "relative",
      }}
    >
      <Img fluid={data.a9.childImageSharp.fluid} fadeIn />
      <Fade in timeout={3000}>
        <Title text1={line1} text2={line2} />
      </Fade>
    </Grid>
  );
};

Header.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Header;
